import { render } from "./servicesswiper.vue?vue&type=template&id=0659933e&scoped=true"
import script from "./servicesswiper.vue?vue&type=script&lang=js"
export * from "./servicesswiper.vue?vue&type=script&lang=js"

import "./servicesswiper.vue?vue&type=style&index=0&id=0659933e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0659933e"]])

export default __exports__